let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3Edvu")).then(() => parcelRequire('eYFK8'));